const ShowField = () => {
  const form = document.getElementById('ContactForm')
  if ( !form ) return

  const fieldGroup = form.querySelector('[sh-field-group]')
  const fieldTrigger = fieldGroup.querySelector('[sh-field-trigger]')
  const fieldTarget = fieldGroup.querySelector('[sh-field-target]')

  fieldTrigger.addEventListener('change', (e) => {
    const value = e.target.value
    const isOther = value === 'other'

    if ( isOther && fieldTarget.classList.contains('d-none') ) {
      fieldTarget.classList.remove('d-none')
    } else if ( !isOther && !fieldTarget.classList.contains('d-none') ) {
      fieldTarget.classList.add('d-none')
    }
  })
}

export default ShowField